export default "__VITE_ASSET__CdgxaD86__"